import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import SubNavLayoutDesign from "./SubNavLayoutDesign";
import Feature from "./Feature";
import "./category.css";

const clients = [
  {
    id: "jessa18",
    name: "Jessa 18",
    desc:
      "This event is one of the important events that our clients will truly treasure. It's their daughter's 18th birthday and they want to give her the best birthday she will ever have. What is a party without its guests? Redtomato Design Studio made sure to provide them with the beautiful looking invitation letters that are to be handed out.",
    features: [
      {
        id: 1,
        desc:
          "This event is one of the important events that our clients will truly treasure. It's their daughter's 18th birthday and they want to give her the best birthday she will ever have.",
        img:
          "https://res.cloudinary.com/doddfudab/image/upload/v1542869368/rtds_work/Jessa%27s%2018th/Jessa_18th_Invi-01.png"
      },
      {
        id: 2,
        desc:
          "What is a party without its guests? Redtomato Design Studio made sure to provide them with the beautiful looking invitation letters that are to be handed out.",
        img:
          "https://res.cloudinary.com/doddfudab/image/upload/v1542882315/rtds_work/Jessa%27s%2018th/Invitation-Card-_-Envelope.jpg"
      }
    ]
  },
  {
    id: "omg",
    name: "Oil My Goodness",
    desc:
      "Oil My Goodness-OMG is an all-natural skincare brand that is here for one thing: to give people a better, healthier alternative. Since 2010, They have been an advocate of the power of mother nature when it comes to beauty.",
    features: [
      {
        id: 1,
        desc:
          "Oil My Goodness-OMG is an all-natural skincare brand that is here for one thing: to give people a better, healthier alternative. Since 2010, They have been an advocate of the power of mother nature when it comes to beauty.",
        img:
          "https://res.cloudinary.com/doddfudab/image/upload/v1543051786/rtds_work/OMG%20Events/lipbalm_packaging2_withbleed-xmas2.png"
      },
      {
        id: 2,
        desc:
          "Season of Christmas has come? Don't fret, Redtomato Design Studio got you! We can create layouts for any events and season. Just ask away!",
        img:
          "https://res.cloudinary.com/doddfudab/image/upload/v1543051792/rtds_work/OMG%20Events/lipbalm_packaging2_withbleed-xmas.png"
      }
    ]
  },
  {
    id: "mck",
    name: "MCK",
    desc: "",
    features: [
      {
        id: 1,
        desc:
          "MCK Fresh Flowers is provides flowers in supermarkets and big malls like SM, Robinsons, Shopwise and Rustans. They sell fresh cut flowers local and imported. They make arrangements for any occasions and accepts flower delivery to selected locations.",
        img:
          "https://res.cloudinary.com/doddfudab/image/upload/v1542865544/rtds_work/MCK/MCK-Fresh-Flowers-Logo-04.jpg"
      },
      {
        id: 2,
        desc:
          "If you are in need of fresh cut flowers, for your loved ones, a party or you want to start a flower business of your own, then MCK Fresh Flowers is perfect for you!",
        img:
          "https://res.cloudinary.com/doddfudab/image/upload/v1542865611/rtds_work/MCK/MCKPoster3-cMockup.jpg"
      }
    ]
  }
];

class LayoutDesign extends Component {
  render() {
    const id = this.props.match.params.id;
    const selected = clients.filter((item, i) => item.id === id);
    return (
      <div className="web-systems">
        <div className="banner-container">
          <span className="banner-text">Spice up your game with layouts!</span>
          <div className="banner">
            <img
              src="https://res.cloudinary.com/doddfudab/image/upload/v1555275954/rtds_work/layoutdesign/rtds_work_Jessa_s-18th_Save-The-Date-Card_png_shadow.png"
              alt="banner"
              className="banner"
            />
          </div>
        </div>
        <SubNavLayoutDesign />
        {selected[0] ? (
          <Feature
            data={selected[0] ? selected[0].features : []}
            desc={selected[0].desc}
          />
        ) : (
          <Feature
            data={clients[0] ? clients[0].features : []}
            name={clients[0].name}
            desc={clients[0].desc}
          />
        )}
      </div>
    );
  }
}

export default withRouter(LayoutDesign);



// WEBPACK FOOTER //
// ./src/components/pages/category/LayoutDesign.js